/* eslint-disable react/no-array-index-key */
import { Button, Flex } from '@aloft/toolkit-sui';
import { useFormContext, useWatch } from 'react-hook-form';
import { MlsListingInfo } from './types.ts';
import { MLSInput } from './MLSInput.tsx';

export const MLSInputs = () => {
  const { setValue, getValues } = useFormContext();
  const mlsCount: number = useWatch({ name: 'mlsListings.length' });
  const handleAddMLS = () => {
    const mlsListings = getValues('mlsListings');
    setValue('mlsListings', [...mlsListings, {
      mls: '',
      mlsListingID: '',
    }]);
  }

  const handleRemoveMLS = (index: number) => {
    const mlsListings: MlsListingInfo[] = getValues('mlsListings');
    setValue('mlsListings', mlsListings.filter((_: MlsListingInfo, i: number) => i !== index));
  }

  return (
    <Flex gap={3} flexDirection="column">
      {Array.from({ length: mlsCount }).map((_, index) => (
        <MLSInput key={`mls_${index}`} index={index} onRemove={handleRemoveMLS} />
      ))}
      <Flex>
        <Button variant="inline" onClick={handleAddMLS} text="Add another entry" icon="add-circle" />
      </Flex>
    </Flex>
  );
};
